import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cCpyList from './cCpyList';

class iCpyList extends cCpyList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }
    
  $id_stgs = {
    cLoadCnd: () => bf.q(''),
  };

  _role = () => {
    let _role = bf.b([
      {
        b_when: global.c?.state.sgc_pageRole == 'own1',
        o_then: () => 'own2',
      },
    ]);
//bf.l('33:{}'.f(_role))
    return _role;
  };

  render() {
//      <ce.RootList
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={true}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
//            sgc_pageRole: 'own2',
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iCpyDtl',
            sgc_pageKey: '',
            sgc_pageMode: 'new',
            sgc_pagePrc: '',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        d_hdrs={{
          pfx: iv._get_hdrPfx('法人一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        n_bdyW={ic.gn_w}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm20ss',
//              nextRole: 'own2',
//              nextRole: global.c?.state.sgc_pageRole,
              nextRole: global.c?._role(),
              nextPage: 'iCpyDtl',
              pagePntKeyName: 'cm20_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
};

export default iCpyList;
